import { type UseQueryResult, useQuery } from 'react-query';
import {
  PermissionService,
  Wealthlane_AppServices_Features_DistributablePermissionListingDto,
} from '../../services/wealthlane-identity-services';

const useGetFeaturesPermissionsDistributable = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AppServices_Features_DistributablePermissionListingDto | undefined,
  unknown
> => {
  const featuresPermissionsDistributable = useQuery(
    ['getFeaturesPermissionsDistributable'],
    async () => {
      return await handleRequest(
        PermissionService.getApiIdentityFeaturesPermissionsDistributable()
      );
    }
  );

  return featuresPermissionsDistributable;
};

export default useGetFeaturesPermissionsDistributable;
